var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i-wysiwyg"},[_c('btn',{attrs:{"l":_vm.label,"i":"pencil","size":"medium"},on:{"press":_vm.editWysiwyg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }